/* eslint-disable no-dupe-keys */
export default {
  order_settlement: {
    name: '订单结算',
    // 属性（一般与对象内容匹配）
    prop: {
      ev_charging_station_settlement: '站结算'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      ev_charging_station_settlement_id: '站结算',
      order_id: '订单',
      net_income_amount: '净收入',
      transaction_fee_amount: 'ECMP手续费',
      sharing_amount: 'ECMP分成',
      sharing_discount_amount: '平台分成优惠',
      sharing_bef_discount_amount: '平台优惠前分成',
      evcs_sharing_amount: '代理价优惠',
      evcs_transaction_fee_amount: '代理商手续费',
      created_at: '结算时间',
      charging_finished_at: '充电结束时间',
      order_station: '订单/电站',
      station_settlement: '站结算记录',
      order_amount: '订单金额',
      service_provider_id: '运营商',
      ev_charging_station_id: '充电站',
      charging_card_amount: '充电卡支付金额',
      discount_amount: '订单优惠金额',
      service_amount_after_discount: '优惠后服务费',
      settled_discount_amount: '结算优惠金额'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      order_info: '订单信息',
      station_settlement: '站结算信息'
    },
    labels: {
      order_service_amount: '服务费',
      order_consumed_power: '电量',
      order_charge_amount: '电费'
    },
    placeholder: {
      search_keyword: '结算/订单编号'
    }
  }
}
